import React, {Fragment} from "react";
import HomeBannerCSS from "./HomeBanner.module.scss";

const HomeBanner = () => {
  return (
    <Fragment>
      <div className={`main-section ${HomeBannerCSS.HomeMain}`}>
        <div className={`container ${HomeBannerCSS.HomeMain_row}`}>
          <div className={HomeBannerCSS.HomeMainContentWrapper}>
            <h3>
              Simple & Secure EMDR Therapy Tools For Clinicians
            </h3>
            <p className={HomeBannerCSS.HomeMainDescription}>
              Industry-leading app for EMDR therapy. Work with your clients
              online using advanced ADDV Minds stimulation tools with secure
              HIPAA/GDRP compliant video conferencing.
            </p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default HomeBanner;
